module.exports = __webpack_public_path__ + "707a8d4339215f1a42b79820b7d4d9c5.png";